import { useState } from "react";
import { jwtDecode } from "jwt-decode";
import { MAIN_API } from "../../api/apilist";
import { getMetaBrowserSignals } from "../../helpers/metaPixel";

export default function CloverCheckoutButton({
  eventId, quantity, couponcode, referralToken, name, email, phone, additionalInfo, state, authToken, items, onInitiateCheckout,
}) {
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);

  async function startCheckout() {
    setLoading(true);
    setErr(null);
    try {
      if (typeof onInitiateCheckout === "function") onInitiateCheckout();
      const { id, _id } = jwtDecode(authToken) || {};
      const userId = id || _id;

      const res = await fetch(`${MAIN_API}/api/payment/clover/checkout`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${authToken}` },
        body: JSON.stringify({
          // Campos legacy para compatibilidad
          eventid: eventId,
          quantity,
          couponcode,
          referralToken,
          name,
          email,
          phone,
          additionalInfo,
          state,
          userId, // <- coincide con el back
          // Nuevo: line items del carrito para múltiples tipos
          items: Array.isArray(items) ? items : undefined,
          // Meta Conversions API match signals (fbp/fbc cookies + landing URL).
          ...getMetaBrowserSignals(),
        }),
      });

      const json = await res.json();
      if (!res.ok) throw new Error(json.message || "Error al iniciar el checkout");

      // ✅ tomar todo desde json.info
      const href = json.info?.href;
      const sid  = json.info?.checkoutSessionId;
      const oid  = json.info?.orderId;

      if (!href || !sid) throw new Error("Checkout URL o SessionId no recibidos");

      localStorage.setItem("checkoutSessionId", sid);
      localStorage.setItem("lastOrderId", oid || "");
      window.location.href = href;
    } catch (e) {
      setErr(e.message || "No se pudo iniciar el checkout");
      setLoading(false);
    }
  }

  return (
    <div>
      <button disabled={loading} onClick={startCheckout}>
        {loading ? "Redirigiendo..." : "Pagar con Clover"}
      </button>
      {err && <p style={{ color: "red" }}>{err}</p>}
    </div>
  );
}
